import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import {
  Countries,
  DashboardLabelsFacade,
  States,
} from '@cpm-pr1618003/ng-initializer-lib';
import {
  catchError,
  combineLatest,
  filter,
  map,
  Observable,
  of,
  take,
  timeout,
} from 'rxjs';
import { InitFacade } from 'src/app/store/facade/init.facade';
import { AccountInfo } from 'src/app/store/state/init.state';

const AUTH_GUARD_TIMEOUT_MS = 10000;

export const authGuardFn: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const router: Router = inject(Router);
  const initFacade: InitFacade = inject(InitFacade);
  const dashboardLabelsFacade: DashboardLabelsFacade = inject(
    DashboardLabelsFacade,
  );

  return combineLatest([
    initFacade.accountInfo$,
    dashboardLabelsFacade.countries$,
    dashboardLabelsFacade.states$,
  ]).pipe(
    filter(
      ([accountInfo, countries, states]: [
        AccountInfo,
        Countries[],
        States[],
      ]) =>
        !!accountInfo &&
        Array.isArray(countries) &&
        countries.length > 0 &&
        Array.isArray(states) &&
        states.length > 0,
    ),
    map(([accountInfo]: [AccountInfo, Countries[], States[]]) => {
      if (accountInfo?.custId) {
        return true;
      } else {
        return router.createUrlTree(['/error-page']);
      }
    }),
    take(1),
    timeout(AUTH_GUARD_TIMEOUT_MS),
    catchError(() => of(router.createUrlTree(['/error-page']))),
  );
};
